import { render, staticRenderFns } from "./AddColour.vue?vue&type=template&id=a15377b0"
import script from "./AddColour.vue?vue&type=script&lang=js"
export * from "./AddColour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports